import React from 'react';

interface IconProps {
  icon: any;
  size?: number;
  color?: string;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ icon: IconComponent, size = 24, color, className }) => {
  if (typeof IconComponent === 'function') {
    try {
      return <IconComponent size={size} color={color} className={className} />;
    } catch {
      return <span>●</span>;
    }
  }
  return <span>●</span>;
};